import request from '../../axios';

export const postSubBrandProduct = async (payload: IAddProductpayload) => {
  const response = await request.post(
    `/api/v2/store/create/sub-brand`,
    payload,
  );

  return response;
};
